// 國際化管理模組 - 支援英文與繁體中文（台灣）
import en from "./en";
import zhTW from "./zhTW";

// 語言包映射
const languages = {
  en,
  "zh-TW": zhTW,
};

// 語言顯示名稱
export const languageNames = {
  en: "English",
  "zh-TW": "中文",
};

// 取得語言包
export const getTranslations = (locale) => {
  return languages[locale] || languages.en;
};

export default languages;
